import { Col, Divider, Flex, Form, Modal, Row, Space, Typography } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { PrinterIcon } from 'assets/svg';
import { Button, ButtonAction, InputForm } from 'components';
import PrintIcon_v2 from 'components/Icons/PrintIcon_v2';
import { useUser } from 'contexts/UserProvider';
import React, { useEffect, useState } from 'react';
import formatNumber, {
  formatNumber_v2,
  handleOnChangeNumber,
  handleOnChangeNumberWithDecimal,
} from 'utils/constants/functions';

interface IProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  data: any;
  handleOk: (values: any) => void;
}

const ModalHandover = (props: IProps) => {
  const { isOpen, setIsOpen, data, handleOk } = props;
  const { user } = useUser();
  const [form] = useForm();
  const [isPrint, setIsPrint] = useState(false);

  const handleCancel = () => {
    setIsOpen(false);
  };

  const handlePrint = () => {
    setIsPrint(true);
  };

  useEffect(() => {
    if (isPrint) {
      window.print();
      setIsPrint(false);
    } else if (isOpen) {
      form.setFieldsValue({
        needConfirm: formatNumber_v2(
          user?.isStorekeeper ? data?.totalOrderQ10 : data?.totalFinalPrice,
        ),
        confirm: user?.isStorekeeper
          ? data?.handOverQ10
            ? formatNumber_v2(data?.handOverQ10)
            : undefined
          : data?.handOverFinalPrice
            ? formatNumber_v2(data?.handOverFinalPrice)
            : undefined,
      });
    } else {
      form.resetFields();
    }
  }, [isPrint, data]);
  return (
    <Modal
      open={isOpen}
      title={
        <Typography.Text className="text-xl font-bold">
          Xác nhận bàn giao
        </Typography.Text>
      }
      onCancel={handleCancel}
      width={'50%'}
      closable={!isPrint}
      footer={[
        <Row
          justify={'space-between'}
          key="submit"
          className={`rounded-b-lg bg-[#f0f3f8] px-6 py-3 ${isPrint && 'pb-56'}`}
        >
          {isPrint ? (
            <>
              <div></div>
              <Typography.Text className="text-xl font-bold">
                Người xác nhận
              </Typography.Text>
            </>
          ) : (
            <>
              <Button
                handleOnclick={handlePrint}
                title="In"
                customClass="text-[#103056]"
                iconBefore={<PrintIcon_v2 />}
              />
              <Flex key={'handle'} justify="flex-end" gap={10}>
                <Button handleOnclick={handleCancel} title="Huỷ" />
                <Button
                  title={
                    user?.isStorekeeper
                      ? 'Thủ kho xác nhận q10'
                      : 'Thủ quỹ xác nhận tiền'
                  }
                  handleOnclick={() => {
                    // console.log(
                    //   'handleOk',
                    //   form
                    //     .getFieldValue('confirm')
                    //     .toString()
                    //     .replace(/\./g, '')
                    //     .replace(',', '.'),
                    // );
                    handleOk({
                      ...data,
                      confirm: parseFloat(
                        form
                          .getFieldValue('confirm')
                          .toString()
                          .replace(/\./g, '')
                          .replace(',', '.'),
                      ),
                    });
                  }}
                  fill
                />
              </Flex>
            </>
          )}
        </Row>,
      ]}
      classNames={{
        content: '!p-0',
        header: '!px-5 !pt-3',
      }}
    >
      <Form form={form} layout="vertical">
        <Divider className="mt-0 mb-4" />
        <Space direction="vertical" className="w-full px-6">
          <Typography.Text className="text-base font-bold">
            {`[${data.sapCustomerId}] ${data?.customerName}`}
          </Typography.Text>
          <Flex gap={5}>
            <p className="w-12 text-sm">Đội:</p>
            <Typography.Text
              className="text-sm font-bold"
              ellipsis={{
                tooltip: `${data.teamSalesIdSap}-${data?.teamSalesName}`,
              }}
            >
              {`${data.teamSalesIdSap}-${data?.teamSalesName}`}
            </Typography.Text>
          </Flex>
          <Flex gap={5}>
            <p className="w-12 text-sm">Tuyến:</p>
            <Typography.Text
              className="text-sm font-bold"
              ellipsis={{ tooltip: `${data.routeId}-${data?.routeName}` }}
            >
              {`${data.routeId}-${data?.routeName}`}
            </Typography.Text>
          </Flex>
          <Form.Item
            name="needConfirm"
            label={user?.isStorekeeper ? 'TL (chỉ)' : 'Thành tiền'}
            className="mb-2"
            layout="vertical"
          >
            <InputForm
              suffix={
                <p className="text-[#909294]">
                  {user?.isStorekeeper ? 'Chỉ' : 'VND'}
                </p>
              }
              placeholder={user?.isStorekeeper ? 'TL (chỉ)' : 'Thành tiền'}
              disabled
              // onChange={(e) => {
              //   user?.isStorekeeper
              //     ? handleOnChangeNumberWithDecimal(e, form)
              //     : handleOnChangeNumber(e, form);
              // }}
            />
          </Form.Item>
          <Form.Item
            name="confirm"
            label={
              user?.isStorekeeper ? 'TL xác nhận (chỉ)' : 'Thành tiền xác nhận'
            }
            className="mb-2"
            layout="vertical"
          >
            <InputForm
              suffix={
                <p className="text-[#909294]">
                  {user?.isStorekeeper ? 'Chỉ' : 'VND'}
                </p>
              }
              placeholder={
                user?.isStorekeeper
                  ? 'Nhập TL xác nhận (chỉ)'
                  : 'Nhập thành tiền xác nhận'
              }
              onChange={(e) => {
                user?.isStorekeeper
                  ? handleOnChangeNumberWithDecimal(e, form)
                  : handleOnChangeNumber(e, form);
              }}
            />
          </Form.Item>
        </Space>
      </Form>
    </Modal>
  );
};

export default ModalHandover;
